var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[_c('router-view'),(_vm.isAuthenticated())?_c('page-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }